<template>
    <svg
        v-if="outline"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M24.8999 25C25.4573 25 25.736 25 25.9692 24.9631C27.2529 24.7597 28.2597 23.753 28.463 22.4693C28.4999 22.2361 28.4999 21.9574 28.4999 21.4V10.6C28.4999 10.0426 28.4999 9.76389 28.463 9.53069C28.2597 8.24702 27.2529 7.24025 25.9692 7.03693C25.736 7 25.4573 7 24.8999 7"
            stroke="currentColor"
            :stroke-width="strokeWidth"
        />
        <path
            d="M8.1 25C7.54259 25 7.26389 25 7.03069 24.9631C5.74702 24.7597 4.74025 23.753 4.53693 22.4693C4.5 22.2361 4.5 21.9574 4.5 21.4V10.6C4.5 10.0426 4.5 9.76389 4.53693 9.53069C4.74025 8.24702 5.74702 7.24025 7.03069 7.03693C7.26389 7 7.54259 7 8.1 7"
            stroke="currentColor"
            :stroke-width="strokeWidth"
        />
        <path
            d="M8.1001 11.2C8.1001 7.80588 8.1001 6.10883 9.15451 5.05441C10.2089 4 11.906 4 15.3001 4H17.7001C21.0942 4 22.7913 4 23.8457 5.05441C24.9001 6.10883 24.9001 7.80588 24.9001 11.2V20.8C24.9001 24.1941 24.9001 25.8912 23.8457 26.9456C22.7913 28 21.0942 28 17.7001 28H15.3001C11.906 28 10.2089 28 9.15451 26.9456C8.1001 25.8912 8.1001 24.1941 8.1001 20.8V11.2Z"
            stroke="currentColor"
            :stroke-width="strokeWidth"
        />
        <circle
            cx="16.4994"
            cy="12.7429"
            r="2.74286"
            stroke="currentColor"
            :stroke-width="strokeWidth"
        />
        <ellipse
            cx="16.4999"
            cy="20.2858"
            rx="4.8"
            ry="2.74286"
            stroke="currentColor"
            :stroke-width="strokeWidth"
        />
    </svg>
    <svg
        v-else
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            x="4"
            y="7"
            width="24"
            height="18"
            rx="2.66667"
            fill="currentColor"
        />
        <path
            d="M24.3999 25C24.9573 25 25.236 25 25.4692 24.9631C26.7529 24.7597 27.7597 23.753 27.963 22.4693C27.9999 22.2361 27.9999 21.9574 27.9999 21.4V10.6C27.9999 10.0426 27.9999 9.76389 27.963 9.53069C27.7597 8.24702 26.7529 7.24025 25.4692 7.03693C25.236 7 24.9573 7 24.3999 7"
            stroke="currentColor"
            :stroke-width="strokeWidth"
        />
        <path
            d="M7.6 25C7.04259 25 6.76389 25 6.53069 24.9631C5.24702 24.7597 4.24025 23.753 4.03693 22.4693C4 22.2361 4 21.9574 4 21.4V10.6C4 10.0426 4 9.76389 4.03693 9.53069C4.24025 8.24702 5.24702 7.24025 6.53069 7.03693C6.76389 7 7.04259 7 7.6 7"
            stroke="currentColor"
            :stroke-width="strokeWidth"
        />
        <path
            d="M7.6001 11.2C7.6001 7.80588 7.6001 6.10883 8.65451 5.05441C9.70893 4 11.406 4 14.8001 4H17.2001C20.5942 4 22.2913 4 23.3457 5.05441C24.4001 6.10883 24.4001 7.80588 24.4001 11.2V20.8C24.4001 24.1941 24.4001 25.8912 23.3457 26.9456C22.2913 28 20.5942 28 17.2001 28H14.8001C11.406 28 9.70893 28 8.65451 26.9456C7.6001 25.8912 7.6001 24.1941 7.6001 20.8V11.2Z"
            fill="currentColor"
            stroke="#619B23"
            :stroke-width="strokeWidth"
        />
        <circle
            cx="15.9994"
            cy="12.7429"
            r="2.74286"
            fill="#619B23"
            stroke="#619B23"
            :stroke-width="strokeWidth"
        />
        <ellipse
            cx="15.9999"
            cy="20.2858"
            rx="4.8"
            ry="2.74286"
            fill="#619B23"
            stroke="#619B23"
            :stroke-width="strokeWidth"
        />
    </svg>
</template>

<script>
export default {
    name: "UserOnCardsIcon",
    props: {
        outline: {
            type: Boolean,
            default: true,
        },
        strokeWidth: {
            type: String,
            default: "1.2",
        },
    },
    setup() {
        return {};
    },
};
</script>
